import { Button } from "@mui/material";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { notFoundPageStyles } from "./styles";

const NotFound: React.FC = () => {
  useEffect(() => {
    document.title = "Page Not Found - OmMuse";
  });
  return (
    <div style={notFoundPageStyles.notFoundPageContainer}>
      <h1>{"The page you're looking for can't be found."}</h1>
      <Link to="/" style={{ marginTop: 40, textDecoration: "none" }}>
        <Button variant="contained" sx={notFoundPageStyles.goToMainPageButton}>
          Go to Main Page
        </Button>
      </Link>
    </div>
  );
};

export default NotFound;
